import GET_SITEPLUS_CATEGORIES from '@/graphql/GET_SITEPLUS_CATEGORIES.gql'
import GET_SITEPLUS_TEMPLATES from '@/graphql/GET_SITEPLUS_TEMPLATES.gql'
import SELECT_TEMPLATE from '@/graphql/SELECT_TEMPLATE.gql'
import { mapState } from 'vuex'

const templatePickerMixin = {
  computed: {
    ...mapState(['services'])
  },
  apollo: {
    siteplusCategories: {
      skip () {
        return Boolean(!this.services.sitepluswebsite)
      },
      query: GET_SITEPLUS_CATEGORIES,
      variables () {
        return { sitePlusWebsiteId: this.services.sitepluswebsite }
      },
      update (data) {
        return data.sitePlusTemplateCategoryList
      },
      error (error) {
        this.errors = JSON.stringify(error.message)
        return []
      },
      fetchPolicy: 'network-only'
    }
  },
  methods: {
    async getSiteplusTemplates (category, page = 1) {
      if (this.services.sitepluswebsite) {
        try {
          const { data } = await this.$apollo.query({
            query: GET_SITEPLUS_TEMPLATES,
            variables: {
              sitePlusWebsiteId: this.services.sitepluswebsite,
              page: page,
              category: category
            },
            fetchPolicy: 'network-only'
          })
          if (data.sitePlusTemplatePage) {
              return data.sitePlusTemplatePage
          }
          return {}
        } catch (err) {
          return {}
        }
      }
      return {}
    },
    async selectTemplate (templateId, useAccountProfile = true) {
      if (this.services.sitepluswebsite) {
        try {
          const { data } = await this.$apollo.mutate({
            mutation: SELECT_TEMPLATE,
            variables: {
              sitePlusWebsiteId: this.services.sitepluswebsite,
              templateId: templateId,
              useAccountProfile: useAccountProfile
            }
          })

          if (data.sitePlusWebsiteTemplateAssign) {
            return data.sitePlusWebsiteTemplateAssign
          }
          return false
        } catch (err) {
          return false
        }
      }
      return false
    }
  }

}

export default templatePickerMixin
